import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './UpgradePlanCards.module.css';

import checkmark from '../../../../assets/changeCoverage/plans/checkmark.svg';
import checkmarkButton from '../../../../assets/changeCoverage/plans/check-nobold.svg';
import accidentOnlyIcon from '../../../../assets/changeCoverage/plans/icon-heart-beat.svg';
import accidentOnlyIllnessIcon from '../../../../assets/changeCoverage/plans/icon-heart-shine.svg';

import { currencyFormat } from '../../../../services/utils';
import { IPG_COVERAGE_TYPE } from '../../../../constants';

export const UpgradePlanCard = ({
  coveredItems = [],
  description = '',
  id = 0,
  isSelected = false,
  monthly = false,
  onClick = () => { },
  price = 0,
  title = '',
}) => {
  const { t } = useTranslation('changeCoverage');

  const iconData = useMemo(
    () => (id === IPG_COVERAGE_TYPE.accidentOnly
      ? accidentOnlyIcon
      : accidentOnlyIllnessIcon),
    [id],
  );

  return (
    <div
      className={styles.container}
      data-selected={isSelected}
      id={`upgrade-${id}`}
    >
      <div className={styles.header}>
        <div className={styles.titleData}>
          <h2>{title}</h2>

          <p>{description}</p>
        </div>

        <img alt="" className={styles.planImg} src={iconData} />
      </div>

      <div className={styles.covered}>
        <h3>{t('prop103.whatsCovered')}</h3>

        <ul className={styles.coveredList}>
          {coveredItems.map((cover) => (
            <li key={cover}>
              <img alt="" src={checkmark} />

              {cover}
            </li>
          ))}
        </ul>
      </div>

      <hr className={styles.headerSeparator} />

      <div className={styles.priceContainer}>
        <span>
          {t(`prop103.${monthly ? 'monthlyPrice' : 'yearlyPrice'}`, {
            price: currencyFormat({ fixed: 2, value: price }),
          })}
        </span>

        <button
          className={styles.selectButton}
          data-selected={isSelected}
          onClick={onClick}
          type="button"
        >
          {isSelected
            ? (
              <>
                <img alt="" src={checkmarkButton} />

                <span>{t('prop103.selected')}</span>
              </>
            ) : t('prop103.select', { escapeValue: false, name: title })}
        </button>
      </div>
    </div>
  );
};
